import { Grid } from '@material-ui/core';
import ChevronCardButtonList from 'components/ChevronCardButtonList';
import { CASABLANCA, FILTERS } from 'components/MapFilter/constants';
import { SmallSectionHeader } from 'components/Typography';
import { LOCATION_HISTORY_SOURCE } from 'constants/globalConstants';
import messages from 'containers/AMCDashboard/services/messages';
import { StyledShortBody } from 'containers/AMCDashboard/services/styles';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { translate } from 'helpers/intl';
import { sanlamDarkGrayishBlue, sanlamVeryLightgray } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PAGES from 'routes/pages';
import {
  getLocations,
  setAMCDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { StoreContext } from 'utils/contextStore';

export interface ServicesBlocPropsType {
  intl: IntlShape;
  mdGrid?: any;
  smGrid?: any;
  setAMCDetailsPageBreadcrumbsPath?: Function;
}
const ServicesBloc = (props: ServicesBlocPropsType) => {
  const lang = useSelector(getLocaleSelector);

  const { organismeListState } = React.useContext(StoreContext);
  const getOrganismeList = organismeListState?.organismeList;

  const hasDM = getOrganismeList?.length > 0;

  const items = [
    hasDM && {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.dmoDelarations }, props)}
        </StyledShortBody>
      ),
      icon: 'SuivreMesDeclarations',
      path: PAGES.AMC_DETAILS,
      BreadcrumbsPath: [
        {
          name: 'amc',
          route: PAGES.AMC_DASHBOARD,
        },
        {
          name: 'suiviDesDemandes',
        },
      ],
    },
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.medicationList }, props)}
        </StyledShortBody>
      ),
      isNew: true,
      icon: 'medications',
      onPress: /* istanbul ignore next */ () => {
        GATracking.event(
          EVENT_CATEGORIES.INFO_MEDICATION,
          EVENT_ACTION.CLICK,
          'Liste des medicaments',
        );
        window.open(
          `https://saydalia.ma/${
            lang ?? 'fr'
          }/medicaments/?utm_source=SANLAM&utm_medium=Medicaments&utm_campaign=visite`,
        );
      },
      category: EVENT_CATEGORIES.INFO_MEDICATION,
      label: 'Liste des medicaments',
    },
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.drugstores }, props)}
        </StyledShortBody>
      ),
      isNew: true,
      icon: 'dutyPharmacies',
      onPress: /* istanbul ignore next */ () => {
        GATracking.event(
          EVENT_CATEGORIES.DRUGSTORES,
          EVENT_ACTION.CLICK,
          'Pharmacies de garde',
        );
        window.open(
          `https://saydalia.ma/${
            lang ?? 'fr'
          }/?utm_source=SANLAM&utm_medium=Homepage&utm_campaign=visite`,
        );
      },
      category: EVENT_CATEGORIES.DRUGSTORES,
      label: 'Pharmacies de garde',
    },
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.findDoctor }, props)}
        </StyledShortBody>
      ),
      icon: 'directoryOfDoctors',
      path: PAGES.SERVICES,
      category: EVENT_CATEGORIES.AMC_ACCUEIL,
      label: 'Mes Services _Localiser les médecins en ligne',
      payload: getLocations({
        filterWith: FILTERS.doctors,
        research: '',
        latitude: CASABLANCA.lat,
        longitude: CASABLANCA.lon,
      }),
      props: {
        source: LOCATION_HISTORY_SOURCE.directoryOfDoctors,
      },
    },
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.findAgent }, props)}
        </StyledShortBody>
      ),
      icon: 'findAgent',
      path: PAGES.SERVICES,
      category: EVENT_CATEGORIES.AMC_ACCUEIL,
      label: 'Mes Services _Localiser les points de dépôt',
      payload: getLocations({
        filterWith: FILTERS.depositPoints,
        research: '',
        latitude: CASABLANCA.lat,
        longitude: CASABLANCA.lon,
      }),
      props: {
        source: LOCATION_HISTORY_SOURCE.findAgent,
      },
    },
  ];
  return (
    <React.Fragment>
      <Grid container>
        <Grid xs={12} item>
          <SmallSectionHeader>
            {translate({ ...messages.myServices }, props)}
          </SmallSectionHeader>
        </Grid>
        <ChevronCardButtonList
          borderColor={sanlamVeryLightgray}
          items={items}
          spacing={2}
          deleteHoverBorder={true}
          mdGrid={props.mdGrid}
          smGrid={props.smGrid}
          setDetailsPageBreadcrumbsPath={props.setAMCDetailsPageBreadcrumbsPath}
        />
      </Grid>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  setAMCDetailsPageBreadcrumbsPath,
};

const mapStateToProps = createStructuredSelector<any, {}>({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ServicesBloc));
export { ServicesBloc };
